import {Group} from '@visx/group';
import {Line} from '@visx/shape';
import React from 'react';

import {ERROR_BAR_LINE_WIDTH, NO_SERIES_ERROR_BAR_COLOR} from './utils/Theme';

export interface ErrorBarProps {
  opacity?: number;
  x: number;
  y1: number;
  y2: number;
  width: number;
  color?: string;
}

export default function ErrorBar({opacity = 1, x, y1, y2, width}: ErrorBarProps): JSX.Element {
  const baseLineProps = {
    strokeOpacity: opacity,
    shapeRendering: 'geometricPrecision',
    stroke: NO_SERIES_ERROR_BAR_COLOR,
    strokeWidth: ERROR_BAR_LINE_WIDTH,
  };

  const baseTickLineProps = {
    ...baseLineProps,
    x1: -width / 2,
    x2: width / 2,
  };

  return (
    <Group left={x} top={0} pointerEvents="none">
      <Line {...baseLineProps} x1={0} x2={0} y1={y1} y2={y2} />
      <Line {...baseTickLineProps} y1={y1} y2={y1} />
      <Line {...baseTickLineProps} y1={y2} y2={y2} />
    </Group>
  );
}
